import { Stack } from "expo-router";
import React from "react";

export default function MyContactsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "My Contacts" }} />
      <Stack.Screen name="[id]" options={{ title: "Contact Details" }} />
      <Stack.Screen name="new" options={{ title: "Add Contact" }} />
    </Stack>
  );
}
